import type { Notification } from "../types/notification.types";

export type NotificationNavigateTarget = {
  pathname: string;
  search: string;
};

/** Solo navega a rutas internas válidas; ignora href legacy con texto plano. */
export function resolveTenantNotificationTarget(
  notification: Pick<Notification, "href" | "materialRequestId">,
): string | null {
  const href = notification.href?.trim();
  if (href?.startsWith("/")) {
    return href;
  }
  if (notification.materialRequestId?.trim()) {
    return `/material-requests/${notification.materialRequestId.trim()}`;
  }
  return null;
}

export function parseNotificationNavigateTarget(
  target: string | null | undefined,
): NotificationNavigateTarget | null {
  const trimmed = target?.trim();
  if (!trimmed?.startsWith("/")) return null;
  const parsed = new URL(trimmed, "http://localhost");
  return { pathname: parsed.pathname, search: parsed.search };
}
